import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import thunk from "redux-thunk";
import Reducers from "./reducers";

const exampleInitialState = {};

export function initializeStore(initialState = exampleInitialState) {
  return createStore(Reducers, initialState, composeWithDevTools(applyMiddleware(thunk)));
}
